// ─── Jours fériés France (dates fixes + mobiles) — porté MoPCal ──
// Calcule les jours fériés d'une année (Pâques par l'algorithme de Meeus/Butcher)
// et expose une recherche par date (AAAA-MM-JJ). Cache par année.
const pad = (n) => String(n).padStart(2, '0');
const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

function paques(annee) {
  const a = annee % 19, b = Math.floor(annee / 100), c = annee % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mois = Math.floor((h + l - 7 * m + 114) / 31);
  const jour = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(annee, mois - 1, jour);
}

// Liste des fériés d'une année : { dk, key (i18n), fr (repli/données) }.
const cacheListe = {};
function feriesAnnee(annee) {
  if (cacheListe[annee]) return cacheListe[annee];
  const p = paques(annee);
  const dec = (n) => { const x = new Date(p); x.setDate(x.getDate() + n); return fmt(x); };
  const liste = [
    { dk: `${annee}-01-01`, key: 'ferie.jourAn',         fr: 'Jour de l\'An' },
    { dk: dec(1),           key: 'ferie.lundiPaques',    fr: 'Lundi de Pâques' },
    { dk: `${annee}-05-01`, key: 'ferie.feteTravail',    fr: 'Fête du Travail' },
    { dk: `${annee}-05-08`, key: 'ferie.victoire1945',   fr: 'Victoire 1945' },
    { dk: dec(39),          key: 'ferie.ascension',      fr: 'Ascension' },
    { dk: dec(50),          key: 'ferie.lundiPentecote', fr: 'Lundi de Pentecôte' },
    { dk: `${annee}-07-14`, key: 'ferie.feteNationale',  fr: 'Fête nationale' },
    { dk: `${annee}-08-15`, key: 'ferie.assomption',     fr: 'Assomption' },
    { dk: `${annee}-11-01`, key: 'ferie.toussaint',      fr: 'Toussaint' },
    { dk: `${annee}-11-11`, key: 'ferie.armistice1918',  fr: 'Armistice 1918' },
    { dk: `${annee}-12-25`, key: 'ferie.noel',           fr: 'Noël' },
  ];
  cacheListe[annee] = liste;
  return liste;
}

// Map dk → nom FR. Utilisé à l'IMPORT (données partagées MoPCal, toujours FR).
const cacheMap = {};
export function joursFeriesFr(annee) {
  if (cacheMap[annee]) return cacheMap[annee];
  const map = Object.fromEntries(feriesAnnee(annee).map(f => [f.dk, f.fr]));
  cacheMap[annee] = map;
  return map;
}

// Nom du jour férié pour une date AAAA-MM-JJ, ou null. `t` (useT) optionnel :
// avec lui, nom traduit à l'AFFICHAGE ; sans lui, repli FR.
export function nomFerie(dk, t) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dk || '')) return null;
  const f = feriesAnnee(+dk.slice(0, 4)).find(x => x.dk === dk);
  if (!f) return null;
  return (t && f.key) ? t(f.key) : f.fr;
}
